import React, { Component } from "react";

import { get, del } from "../../api";

import "./ZeroHits.css";
import { CloseIcon } from "../SVGIcons";

class ZeroHits extends Component {
  state = {
    zeroHits: []
  };

  componentDidMount() {
    this.fetchZeroHits();
  }

  fetchZeroHits = async () => {
    try {
      const zeroHits = await get("/zero-hits");
      this.setState({ zeroHits });
    } catch (err) {
      alert(err.message);
    }
  };

  deleteZeroHit = async zeroHit => {
    await del("/zero-hits/" + zeroHit.id);
    this.setState(state => ({
      zeroHits: state.zeroHits.filter(hit => hit.id !== zeroHit.id)
    }));
  };

  render() {
    const { zeroHits = [] } = this.state;

    return (
      <table className="ZeroHits">
        <thead>
          <tr>
            <th>Query</th>
            <th className="right">Count</th>
            <th className="center">Webshop</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
        {zeroHits.map(function (zeroHit, index) {
          const href = zeroHit.webshops
            ? "https://mylbs.cc/list/" + zeroHit.query + "?searchMode=webshops"
            : "https://mylbs.cc/list/" + zeroHit.query;

          return (
            <tr key={index} >
              <td>
                <a href={href} target="_blank">
                  {zeroHit.query}
                </a>
              </td>
              <td className="right">{zeroHit.count}</td>
              <td className="center">{zeroHit.webshops ? "✅" : ""}</td>
              <td>
                <div>
                  <button className="zero" onClick={() => this.deleteZeroHit(zeroHit)}>
                    <CloseIcon />
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
         </tbody>
      </table>
    );
  }
}

export default ZeroHits;



// WEBPACK FOOTER //
// ./src/components/ZeroHits/ZeroHits.js